import { render, staticRenderFns } from "./ChannelPartnerAgreementTemplateList.vue?vue&type=template&id=dc699a76&scoped=true"
import script from "./ChannelPartnerAgreementTemplateList.vue?vue&type=script&lang=js"
export * from "./ChannelPartnerAgreementTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc699a76",
  null
  
)

export default component.exports